import styled from 'styled-components';
import AppCSS from '../../../../utils/styled';

export const Components = {
  List: styled.ul`
    width: 100%;
    margin: 0;
    padding: 0;
    list-style: none;
    background-color: ${AppCSS.colors.white};
  `,
  Row: styled.li<{ isDragging: boolean; isDropTarget: boolean }>`
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    border-bottom: 1px solid ${AppCSS.colors.greys.light};
    border-top: 2px solid ${(p) => (p.isDropTarget ? AppCSS.colors.blues.darker : 'transparent')};
    opacity: ${(p) => (p.isDragging ? 0.4 : 1)};
    background-color: ${AppCSS.colors.white};
  `,
  Handle: styled.span`
    cursor: grab;
    user-select: none;
    font-size: 18px;
    line-height: 1;
    color: ${AppCSS.colors.greys.medium};
  `,
  Title: styled.span`
    flex: 1;
    ${AppCSS.fonts.label14Regular};
    color: ${AppCSS.colors.blues.veryDark};
  `,
  Meta: styled.span`
    min-width: 64px;
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.medium};
  `,
  Actions: styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
  `,
  ActionButton: styled.button`
    padding: 4px 8px;
    cursor: pointer;
    border: 1px solid ${AppCSS.colors.greys.light};
    border-radius: 4px;
    background-color: ${AppCSS.colors.white};
    ${AppCSS.fonts.label12Medium};
    color: ${AppCSS.colors.blues.veryDark};

    &:disabled {
      cursor: default;
      opacity: 0.4;
    }
  `,
  Hint: styled.span`
    ${AppCSS.fonts.label12Regular};
    color: ${AppCSS.colors.greys.medium};
  `,
  // Sits above the list with a fixed height, so rows don't jump when the buttons appear.
  SaveOrderBar: styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    min-height: 44px;
  `,
  SaveOrderActions: styled.div`
    display: flex;
    align-items: center;
    gap: 12px;
  `,
};
